module.exports = __webpack_public_path__ + "img/sketch-product-mobile.51378ad0.svg";